import { render } from "./UpdatePasswordModal.vue?vue&type=template&id=7372173e"
import script from "./UpdatePasswordModal.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordModal.vue?vue&type=script&lang=js"

import "./UpdatePasswordModal.vue?vue&type=style&index=0&id=7372173e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__